var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167028",
    "data-name": "Group 167028",
    transform: "translate(-297 -378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(301 385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check-2",
    "data-name": "check",
    d: "M20,6,9,17,4,12",
    transform: "translate(-4 -6)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150090",
    "data-name": "Rectangle 150090",
    width: 24,
    height: 24,
    transform: "translate(297 378)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check_mark.c56acf3ebfc3d24eec2ee0b59af473b4.svg";
export { ForwardRef as ReactComponent };